module.exports = "https://99designs-start-assets.imgix.net/js/895fc122eaacfab0aecf997ebda982e0.svg";